module.exports = __webpack_public_path__ + "media/百石元 - 猪突猛進.c11d4976.mp3";